'use client';

import { StoreErrorView } from '@/components/layout/store-error-view';
import { useChunkLoadRecovery } from '@/lib/use-chunk-load-recovery';

/**
 * Parent error boundary for the market subtree. A route segment's own
 * `error.tsx` cannot catch errors thrown by that segment's `layout.tsx`, so this
 * boundary (one level above `[market]/layout.tsx`) is the last line of defense
 * for layout-level failures. CMS-unavailable failures no longer land here:
 * every CMS reader degrades to last-good/snapshot/default config instead of
 * throwing (see src/lib/cms-fallback.ts), so reaching this boundary means
 * something other than the CMS broke the layout render.
 */
export default function StorefrontError({
	error,
	reset,
}: {
	error: Error & { digest?: string };
	reset: () => void;
}) {
	useChunkLoadRecovery(error);

	return (
		<StoreErrorView
			reset={reset}
			eyebrow="Store Temporarily Unavailable"
			title="We'll Be Right Back"
			description="We couldn't load the store right now. Please try again in a moment."
		/>
	);
}
